/**
 * HQ 前端路由權限金鑰 (FrontKey) 定義
 * 用於路由訪問與左側選單顯示控管。
 */
export const FRONT_KEY = Object.freeze({
  // 點數管理
  POINTS: "H3X01",
  POINTS_OVERVIEW: "H3X02",
  POINTS_REDEEM_OVERVIEW: "H3X03",
  POINTS_ACTIVITY_OVERVIEW: "H3X04",
  POINTS_PRODUCT_GIFT_OVERVIEW: "H3X05",
  POINTS_AUDIT_OVERVIEW: "H3X06",

  // 行銷管理
  DOCUMENT: "H4X01",
  PROMOTION_PLAN_OVERVIEW: "H4X02",
  CUSTOMER_RESOURCE_OVERVIEW: "H4X03",
  SMART_FITNESS_BAND_PROMOTION_PLAN_OVERVIEW: "H4X04",

  // 循環訂單
  CYCLE_PURCHASE: "H5X01",
  CYCLE_PURCHASE_VERIFICATION_BILLING_OVERVIEW: "H5X02",
  CYCLE_PURCHASE_BILLING: "H5X03",
  CYCLE_PURCHASE_OVERVIEW: "H5X04",
  CYCLE_PURCHASE_DETAIL: "H5X05",
  CYCLE_PURCHASE_CANCEL_OVERVIEW: "H5X06",

  // Dashboard
  DASHBOARD: "H6X01",
  DASHBOARD_ADVANCED_FILTER: "H6X02",

  // 設備租賃
  DEVICE_RENTAL: "H7X01",
  DEVICE_RENTAL_BATCH_PAYMENT_OVERVIEW: "H7X02",
  DEVICE_RENTAL_BATCH_PAYMENT_BILLING: "H7X02",
  DEVICE_RENTAL_ORDERS_OVERVIEW: "H7X03",

  // 訂單
  ORDERS_VIEW: "H8X02",

  // 財務作業
  FINANCE: "H10X01",
  FINANCE_TRIPLICATE_INVOICE_ALLOWANCE_OVERVIEW: "H10X02",

  // 店鋪管理
  CLUB_MANAGEMENT: "CXX990001",
  CLUB_MANAGEMENT_MEMBERSHIP_SEARCH: "CXX990002",
  CLUB_MANAGEMENT_MEMBERSHIP: "CXX990003",
  CLUB_INVENTORY: "H11X01",
  CLUB_INVENTORY_SHOP_STOCK_OVERVIEW: "H11X02",
  CLUB_INVENTORY_SHOP_STOCK_DETAIL: "H11X02",
  CLUB_INVENTORY_PRODUCT_STOCK_OVERVIEW: "H11X03",
  CLUB_INVENTORY_PRODUCT_STOCK_DETAIL: "H11X03",

  // 加盟店管理
  CLUB_COMPANY: "H12X01",
  CLUB_COMPANY_OVERVIEW: "H12X02",
  CLUB_COMPANY_COMPANY: "H12X03",

  // 開發專用區
  DEVELOP: "D999X01",
  DEVELOP_ICONS: "D999X02",
  DEVELOP_TEST: "D999X03",
  DEVELOP_GRADES: "D999X04",
  DEVELOP_MEMBER_PROFILE: "D999X05",
});
